<!-- https://primefaces.org/primeng/showcase/#/setup -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top" style="background-color: #ffffff">
	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleDepotMode()">Toggle Depot Mode</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleDistrictLockOut()">Toggle District Lockout</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleFacilityLockOut()">Toggle Facility Lockout</button>
		<button class="btn btn-success" style="margin-left: 5px" (click)="onUpdate()">UPDATE</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total depot printers and/or printers with lockout enabled at this district: {{ lstIDPrinterLockout.length }}</label
		><br />
		<label>&#9900; Note: These settings can also be set in CAASSAgent with a Technician Login</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
		<div class="error-div">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 				  	    -->
<!-- Display Location Items -->
<!-- 					    -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->
	<p-table
		#mydt
		[value]="lstIDPrinterLockout"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPrinter"
		dataKey="IDPrinterID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<ng-template pTemplate="header">
			<!-- 				-->
			<!-- Filter Section -->
			<!-- 				-->
			<tr>
				<th class="fixwidth-06">
					<div class="table-filter-row-group">
						<!-- 				   -->
						<!-- Display When Busy -->
						<!-- 				   -->
						<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px">
							<img class="busy-img" src="assets/images/loading.gif" />
						</div>
						<div [style.display]="isBusy == false ? 'block' : 'none'" style="width: 20px"></div>
					</div>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="IDPrinterID_Active" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActive
								[ngModel]="value"
								[options]="lstActive"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="ScanStation" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="FacilityName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="PrinterName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="KeyValue_IsInDepotMode" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsInDepotMode
								[ngModel]="value"
								[options]="lstDepotMode"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="KeyValue_IsDistrictLockOut" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDistrictLock
								[ngModel]="value"
								[options]="lstDistrictLock"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="KeyValue_IsFacilityLockOut" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterFacilityLock
								[ngModel]="value"
								[options]="lstFacilityLock"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr style="height: 4rem">
				<th class="fixwidth-06"></th>
				<th pSortableColumn="IDPrinterID_Active" class="fixwidth-09">Active<p-sortIcon field="IDPrinterID_Active"></p-sortIcon></th>
				<th pSortableColumn="ScanStation">ScanStation<p-sortIcon field="ScanStation"></p-sortIcon></th>
				<th pSortableColumn="FacilityName">Facility Name<p-sortIcon field="FacilityName"></p-sortIcon></th>
				<th pSortableColumn="PrinterName">Printer Name<p-sortIcon field="PrinterName"></p-sortIcon></th>
				<th class="fixwidth-09" pSortableColumn="KeyValue_IsInDepotMode">Depot Mode<p-sortIcon field="KeyValue_IsInDepotMode"></p-sortIcon></th>
				<th class="fixwidth-09" pSortableColumn="KeyValue_IsDistrictLockOut">Lock District<p-sortIcon field="KeyValue_IsDistrictLockOut"></p-sortIcon></th>
				<th class="fixwidth-09" pSortableColumn="KeyValue_IsFacilityLockOut">Lock Facility<p-sortIcon field="KeyValue_IsFacilityLockOut"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rPrinter>
			<tr [pSelectableRow]="rPrinter" (dblclick)="onRowDblClick(rPrinter)">
				<td class="fixwidth-06">
					<!-- Fee space filler -->
				</td>

				<td>
					<div class="fixwidth-09">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-active': rPrinter.IDPrinterID_Active,
								'pi-ban table-inactive': !rPrinter.IDPrinterID_Active
							}"
						></i>
					</div>
				</td>

				<td>
					<div class="table-data-printers">
						{{ rPrinter.ScanStation }}
					</div>
				</td>

				<td>
					<div class="table-data-printers">
						{{ rPrinter.FacilityName }}
					</div>
				</td>

				<td>
					<div
						class="table-data-printers">
						{{ rPrinter.PrinterName }}
					</div>
				</td>

				<td>
					<div
						class="table-data-printers fixwidth-09"
						[ngClass]="{
							'table-color-green': rPrinter.KeyValue_IsInDepotMode == 'True',
							'table-color-red': rPrinter.KeyValue_IsInDepotMode == 'False'
						}">
						{{ rPrinter.KeyValue_IsInDepotMode }}
					</div>
				</td>

				<td>
					<div
						class="table-data-printers fixwidth-09"
						[ngClass]="{
							'table-color-green': rPrinter.KeyValue_IsDistrictLockOut == 'True',
							'table-color-red': rPrinter.KeyValue_IsDistrictLockOut == 'False'
						}">						
						{{ rPrinter.KeyValue_IsDistrictLockOut }}
					</div>
				</td>

				<td>
					<div
						class="table-data-printers fixwidth-09"
						[ngClass]="{
							'table-color-green': rPrinter.KeyValue_IsFacilityLockOut == 'True',
							'table-color-red': rPrinter.KeyValue_IsFacilityLockOut == 'False'
						}">							
						{{ rPrinter.KeyValue_IsFacilityLockOut }}
					</div>
				</td>				
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						  -->
<!-- Display When No Printers -->
<!-- 					      -->
<div style="padding: 20px" [style.display]="lstIDPrinterLockout.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No Printers In Lockout or Depot Mode...</label>
</div>
